module.exports = __webpack_public_path__ + "media/九重安防体系.53bff784.mp4";